import React from 'react'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@material-ui/core/index'
import { strings } from '../../../../localization/strings'
import Loader from '../../../loaders/dots_loader/index'
import { connect } from 'react-redux'
import { AddOrderToGroupReadyForCollect } from '../../../../helpers/restHelpers'

class Component extends React.Component {
    state = { open: false, loading: false }

    handleClickOpen = () => {
        this.setState({ open: true })
    }

    handleClose = (force) => {
        if (force !== true) {
            if (this.state.loading) return
        }
        this.setState({ open: false, loading: false })
    }

    confirm = () => {
        this.setState({ loading: true })
        this.handleClose(true)
        this.props.orderIds ? AddOrderToGroupReadyForCollect(this.props.orderIds) : AddOrderToGroupReadyForCollect([this.props.orderId])
        window.showDialog(
            {
                title: 'Listo!',
                message: 'Cuando superes la cantidad mínima de paquetes listos podrás solicitar su retiro',
            },
            () => {
                this.props.actionDone();
                window.location.reload()
            }
        )
    }

    render() {
        return (
            <div style={{ width: '100%' }}>
                <div onClick={this.handleClickOpen}>
                    {strings.addOrderToGroupButton}
                </div>
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {strings.addOrderToGroupDialogTitle}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText
                            id="alert-dialog-description"
                            style={{ whiteSpace: 'pre-line' }}
                        >
                            {strings.addOrderToGroupDialogText.replace('{{minimumOrders}}', this.props.appStore.minimumGroupToReadyForCollect)}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={this.handleClose}
                            color="primary"
                            disabled={this.state.loading}
                        >
                            {strings.close}
                        </Button>
                        <Button
                            onClick={this.confirm}
                            color="primary"
                            autoFocus
                            disabled={this.state.loading}
                        >
                            {strings.continue}
                        </Button>
                    </DialogActions>
                    {this.state.loading ? <Loader /> : null}
                </Dialog>
            </div>
        )
    }
}

const mapStateToProps = (store)  => {
    return {
        appStore:store.app
    }
};

export default connect(mapStateToProps)(Component)